<template>
  <div style="background-color:white">
    <el-divider></el-divider>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.rwbt">
            <el-input v-model="form.rwbt" :placeholder="'请输入' + lable.rwbt"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3">
          <el-form-item label="执行单位">
            <el-cascader v-model="form.zxdw" clearable style="width:100%" :options="options" :props="props"
              :show-all-levels="true" filterable></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="起始日期" prop="qssj">
            <div class="block">
              <el-date-picker v-model="form.qssj" type="date" value-format="yyyy-MM-dd" style="width:100%"
                placeholder="请选择起始日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1"> </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3"><el-form-item label="截止日期" prop="jhwcsj">
            <div class="block">
              <el-date-picker v-model="form.jhwcsj" type="date" value-format="yyyy-MM-dd" style="width:100%"
                placeholder="请选择截止日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item prop="rwlx" :label="lable.rwlx">
            <el-select v-model="form.rwlx" style="width:100%" placeholder="请选择">
              <el-option v-for="item in optionTasks" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1"> </el-col>
        <el-col :span="6"> </el-col>
        <el-col :span="8" :push="3"><el-form-item prop="zxr" :label="lable.zxr">
            <el-select v-model="form.list" @change="selectChangeHandle" style="width:100%" multiple clearable
              :placeholder="'请选择' + lable.zxr">
              <el-option v-for="item in optionUsers" :key="item.userId" :label="item.userName" :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="19" :push="1"><el-form-item prop="rwnr" label="任务内容">
            <el-input v-model="form.rwnr" type="textarea" placeholder="请输入任务类容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="19" :push="1">
          <el-form-item label="设备列表" align="left">
            <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
              :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="deviceData" tooltip-effect="dark"
              style="width: 100%">
              <el-table-column prop="id" v-if="false"> </el-table-column>
              <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="zcbh" label="资产编号" width="200">
              </el-table-column>
              <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="sbxh" label="规格编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="companyName" label="所属单位" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="id" label="操作" show-overflow-tooltip>
                <template slot="header" slot-scope="scope">
                  <DC :transferValue="transferValue" :personInfo="1" :zxdw="form.zxdw"></DC>
                </template>
                <template slot-scope="scope">
                  <el-button @click="DFile(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="2" :push="8">
          <el-form-item>
            <el-button type="primary" @click="submitCheck" v-preventReClick>确认</el-button>
          </el-form-item></el-col>
        <el-col :span="2" :push="10">
          <el-form-item>
            <el-button type="success" @click="cancel">返回</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  updTask,
  findByIdTask,
  findByIdTaskDevice,
  treeCompany,
  findAllUser,
  findByModule
} from "../../api/api";
import TaskDevice from "../../components/common/TaskDevice.vue";

export default {
  name: "TaskEditing",
  components: {
    "DC": TaskDevice,
  },
  data() {
    return {
      form: {
        delivery: false
      },
      lable: {},
      options: [],
      optionUsers: [],
      props: {
        label: 'companyName',
        value: 'companyName',
        children: 'zcompany',
        expandTrigger: 'click',
        emitPath: false
      },
      optionTasks: [
        {
          id: 1,
          name: "维保"
        }, {
          id: 2,
          name: "检定"
        }, {
          id: 3,
          name: "核查"
        }, {
          id: 4,
          name: "其他"
        }
      ],
      deviceData: [
      ]
    };
  },

  methods: {
    selectChangeHandle() {
      this.$forceUpdate()
    },
    transferValue(outData) {
      for (var i = 0; i < outData.length; i++) {
        this.deviceData.push(outData[i]);
      }
    },
    submitCheck() {
      var arr = [];
      for (var i = 0; i < this.deviceData.length; i++) {
        arr.push(this.deviceData[i].id)
      }
      this.form.deviceIds = arr;
      updTask(this.form).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: data,
            type: "success"
          });
          let val = {
            path: "/task",
            name: "检定信息"
          };
          this.$router.push({
            path: "task"
          });
          this.$store.commit("pushtags", val);
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    cancel() {
      this.$router.push({
        path: "task"
      });
    },
    DFile(row) {
      this.deviceData.splice(this.deviceData.indexOf(row), 1)
    },
    selectCompany() {
      treeCompany().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    //根据id查找任务信息
    findByid(row) {
      findByIdTask(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.form = data;
          var s = this.form.userId.split(',')
          this.form.list = s;
        }
      });
    },
    //根据id查找任务设备信息
    findByIdDevice(row) {
      findByIdTaskDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.deviceData = data;
        }
      });
    },
    selectUser() {
      var user = JSON.parse(localStorage.getItem("user"))
      var map = {
        companyCode: "G065"
      }
      findAllUser(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.optionUsers = data;
        }
      });
    },
    findLable() {
      findByModule("计划任务").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.selectCompany();
    var aid = sessionStorage.getItem("id");
    this.findByid(aid);
    this.findByIdDevice(aid);
    this.selectUser();
  }
};
</script>

<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>



// WEBPACK FOOTER //
// src/views/task/TaskEditing.vue